import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';

import routing from './monthly_group_report.routes';
import GroupActivePowerService from '../../../components/api/group_active_power/group_active_power.service';
import DailyGroupActivePowerService from '../../../components/api/daily_group_active_power/daily_group_active_power.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import MathUtil from '../../../components/logic/math_util/math_util';
import GroupReportUtil from '../../../components/logic/group_report/group_report_util.service';
import chartConfig from './monthly_group_report.config';

export class MonthlyGroupReportController {
  /*@ngInject*/
  constructor($state, $stateParams, $filter, moment, DateUtil, DailyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.DailyGroupActivePowerService = DailyGroupActivePowerService;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;
    this.moment = moment;

    this.today = this.moment();
    this.targetDate = this.moment($stateParams.target || this.today);
    this.maxDate = this.today.toDate();

    this.downloadFileName = 'active_power.csv';

    this.categories = [];
    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.updateGraph(this.targetDate);
  }

  updateGraph(targetDate) {
    this.startDate = targetDate.clone().startOf('month');
    this.endDate = targetDate.clone().endOf('month');

    let numberOfDays = this.endDate.diff(this.startDate, 'days');
    let startUtc = this.startDate.clone().add(9, 'hours');

    this.categories = [];
    for (let i = 0; i <= numberOfDays; i++) {
      this.categories.push(startUtc.valueOf());
      startUtc.add(1, 'days');
    }

    this.DailyGroupActivePowerService.show(
      angular.extend({id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate.toDate(), this.endDate.toDate())),
      response => {
        [this.seriesList, this.sumSeriesList] = this.formatGroupActivePower(response.powers);

        this.chartConfig.xAxis.categories = this.categories;
        this.chartConfig.xAxis.max = numberOfDays;

        if (this.isOverStackLimit) {
          this.chartConfig.series = this.sumSeriesList;
        } else {
          this.chartConfig.series = this.seriesList;
        }

        //add click event
        for (let series of this.chartConfig.series) {
          series.events = {
            click: event => {
              this.$state.go(
                'main.group_report_show.detail',
                {id: this.id, term: 'daily', target: event.point.date},
                {reload: true}
              )
            }
          };
          series.cursor = 'pointer';
        }

        this.sumSeries = this.sumSeriesList[0];
        this.csvData = this.CsvUtil.processDailyGroupActivePower(this.seriesList, this.categories);
        this.downloadFileName = this.startDate.format('[group_active_power_]YYYY-MM[.csv]');
      }
    )
  }

  formatGroupActivePower(groupActivePowers) {
    if (groupActivePowers.length < 1) {
      return [[], []];
    }

    // 処理内容の詳細については daily_group_report_component.js を参照

    const STACK_LIMIT = 10;
    this.isOverStackLimit = false;

    let firstMeasuredAt = this.moment(groupActivePowers[0].date);
    let beginningDate = this.targetDate.startOf('month');
    let shiftRange = firstMeasuredAt.diff(beginningDate, 'days');

    let seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shiftRange);

    if (seriesList.length > STACK_LIMIT) {
      this.isOverStackLimit = true;
    }

    let [stackSeriesList, sumSeriesList] = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers, shiftRange);

    return [stackSeriesList, sumSeriesList];
  }

  changeMonth(diff) {
    this.targetDate = this.targetDate.add(diff, 'months');

    this.updateGraph(this.targetDate);
  }
}

export default angular.module('leptonApp.monthlyGroupReport', [uiRouter, moment, DateUtil, DailyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil])
  .config(routing)
  .component('monthlyGroupReport', {
    require: {parentComponent: '^groupReportShow'},
    template: require('./monthly_group_report.html'),
    controller: MonthlyGroupReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/group_report/monthly/monthly_group_report.component.js